var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/user fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8333C12.3012 10.8333 14.1667 8.96782 14.1667 6.66663C14.1667 4.36543 12.3012 2.49994 10 2.49994C7.69883 2.49994 5.83334 4.36543 5.83334 6.66663C5.83334 8.96782 7.69883 10.8333 10 10.8333Z",
    fill: "#858C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99362 15.8766C2.99815 13.4448 6.20244 11.6667 10 11.6667C13.7976 11.6667 17.0019 13.4448 18.0064 15.8766C18.3579 16.7273 17.5872 17.5 16.6667 17.5H3.33332C2.41284 17.5 1.64219 16.7273 1.99362 15.8766Z",
    fill: "#858C95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserfill);
export default __webpack_public_path__ + "static/media/user fill.e39cf24ef5d4bf201259b0c0f45ed1f0.svg";
export { ForwardRef as ReactComponent };